import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Vivís en un departamento o espacio reducido.', 'Trabajás fuera de casa y te carcome la culpa de dejarlo solo.', 'Tu perro ladra ante cualquier ruido del pasillo.', 'Ya recibiste advertencias del administrador o notas por debajo de la puerta.'];
  const notForYou = ['Tenés un patio gigante y el perro vive afuera.', 'Tu perro tiene problemas de agresividad grave hacia personas.', 'Buscás una "pastilla mágica" sin dedicarle 15 minutos de atención.'];
  return <section className="py-10 sm:py-20 px-5 sm:px-8 bg-depto-beige" data-id="element-12">
      <div className="max-w-5xl mx-auto grid gap-6 sm:gap-12 md:grid-cols-2" data-id="element-13">
        <FadeIn data-id="element-14">
          <div className="bg-white p-8 sm:p-10 rounded-3xl shadow-sm border-t-4 border-t-green-500 h-full" data-id="element-15">
            <h3 className="text-2xl sm:text-3xl text-depto-brown mb-8" data-id="element-16">
              Este programa es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-17">
              {forYou.map((item, idx) => <li key={idx} className="flex gap-4 items-start" data-id="element-18">
                  <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" data-id="element-19" />
                  <span className="text-depto-brown/80 text-lg" data-id="element-20">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-21">
          <div className="bg-white p-8 sm:p-10 rounded-3xl shadow-sm border-t-4 border-t-red-400 h-full" data-id="element-22">
            <h3 className="text-2xl sm:text-3xl text-depto-brown mb-8" data-id="element-23">
              Este programa NO es para vos si:
            </h3>
            <ul className="space-y-6" data-id="element-24">
              {notForYou.map((item, idx) => <li key={idx} className="flex gap-4 items-start" data-id="element-25">
                  <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-26" />
                  <span className="text-depto-brown/80 text-lg" data-id="element-27">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}